(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lc-category-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lc-category-slider')) {
    customElements.define('lc-category-slider', class extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-viewport]');
        this.previous = this.querySelector('[data-previous]');
        this.next = this.querySelector('[data-next]');
        if (!this.viewport || !this.previous || !this.next) return;
        this.previous.addEventListener('click', () => this.move(-1));
        this.next.addEventListener('click', () => this.move(1));
        this.viewport.addEventListener('scroll', () => this.update(), { passive: true });
        this.addEventListener('mouseenter', () => this.pause());
        this.addEventListener('mouseleave', () => this.play());
        this.addEventListener('focusin', () => this.pause());
        this.addEventListener('focusout', () => this.play());
        new ResizeObserver(() => this.update()).observe(this.viewport);
        this.update();
        this.play();
      }
      disconnectedCallback() { this.pause(); }
      move(direction) {
        const card = this.querySelector('.lc-category-slider__card');
        const track = this.querySelector('.lc-category-slider__track');
        if (!card || !track) return;
        const gap = parseFloat(getComputedStyle(track).gap) || 0;
        this.viewport.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
      }
      update() {
        const max = this.viewport.scrollWidth - this.viewport.clientWidth;
        this.previous.disabled = this.viewport.scrollLeft <= 2;
        this.next.disabled = this.viewport.scrollLeft >= max - 2;
      }
      play() {
        if (this.dataset.autoplay !== 'true' || matchMedia('(max-width: 767px), (prefers-reduced-motion: reduce)').matches) return;
        this.pause();
        const seconds = Number(this.dataset.autoplaySeconds) || 5;
        this.timer = setInterval(() => {
          const max = this.viewport.scrollWidth - this.viewport.clientWidth;
          if (this.viewport.scrollLeft >= max - 2) this.viewport.scrollTo({ left: 0, behavior: 'smooth' });
          else this.move(1);
        }, seconds * 1000);
      }
      pause() { clearInterval(this.timer); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lc-treppenleuchten-editorial"] && !Shopify.designMode) return;
  try {
    
 
  const initLcStairEditorial = (root = document) => {
    root.querySelectorAll('[data-lc-stair-tabs]:not([data-ready])').forEach((tabs) => {
      tabs.dataset.ready = 'true';
      const buttons = [...tabs.querySelectorAll('[role="tab"]')];
      const panels = [...tabs.querySelectorAll('[role="tabpanel"]')];

      const activate = (button, focus = false) => {
        buttons.forEach((item) => {
          const selected = item === button;
          item.classList.toggle('is-active', selected);
          item.setAttribute('aria-selected', selected ? 'true' : 'false');
          item.tabIndex = selected ? 0 : -1;
        });
        panels.forEach((panel) => {
          panel.hidden = panel.id !== button.getAttribute('aria-controls');
        });
        if (focus) button.focus();
      };

      buttons.forEach((button, index) => {
        button.addEventListener('click', () => activate(button));
        button.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let next = index;
          if (event.key === 'ArrowRight') next = (index + 1) % buttons.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + buttons.length) % buttons.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = buttons.length - 1;
          activate(buttons[next], true);
        });
      });
    });

    root.querySelectorAll('[data-lc-stair-gallery]:not([data-ready])').forEach((gallery) => {
      gallery.dataset.ready = 'true';
      const progress = gallery.parentElement.querySelector('.lc-stair-editorial__gallery-progress span');
      const update = () => {
        if (!progress) return;
        const available = gallery.scrollWidth - gallery.clientWidth;
        const ratio = available > 0 ? gallery.scrollLeft / available : 1;
        progress.style.transform = `scaleX(${Math.max(1, ratio * 3.57)})`;
      };
      gallery.addEventListener('scroll', update, { passive: true });
      update();
    });
  };

  initLcStairEditorial();
  document.addEventListener('shopify:section:load', (event) => initLcStairEditorial(event.target));

  } catch(e) { console.error(e); }
})();
})();
